import ServicesJSON from "../services.json";
import { decodeObject } from "./functions";
import { AuthCallbackState, LanguageSelection } from '../types';

const filteringSearchParams = [
    'cancelReservation=', 'filter=', 'base=', 'date=', 'use_geolocation=', 'invoicing_type=', 'time_of_day='
];

export const noFilteringSearchParamsFound = (): boolean => {
    const search = window.location.search;
    if (!search) return true;

    for (const param of filteringSearchParams) {
        if (search.includes(param)) return false;
    }

    return true;
};

/**
 * Parses the value of a request parameter from window.location.search.
 * @param {string} paramName - The name of the request parameter to retrieve.
 * @returns {string|null} The value of the parameter if it exists, otherwise null.
 */
export function getSearchParam(paramName: string): string | null {
    if (typeof window === 'undefined' || !window.location || !window.location.search) {
        return null;
    }
    const params = new URLSearchParams(window.location.search);
    const value = params.get(paramName);
    return value !== null ? value : null;
}

export const removeQueryParameters = (
    history: any,
    location: any,
    paramNames: string[]
): void => {
    const searchParams = new URLSearchParams(location.search);
    let changed = false;

    paramNames.forEach((paramName: string) => {
        if (searchParams.has(paramName)) {
            searchParams.delete(paramName);
            changed = true;
        }
    });

    if (changed) history.replace({
        search: searchParams.toString(),
    });
};

export const getLanguageFromPath = (): LanguageSelection|null => {
    const pathLang = window.location.pathname.slice(0, 4);

    if      (pathLang === '/en/') return 'english';
    else if (pathLang === '/sv/') return 'swedish';

    return null;
};

// Return campaign path determined by the url query parameter and localStorage state variable if
// they are included and match eatch other. Otherwise return an empty string.
export const getCampaignPath = (): string => {
    const request_id = getSearchParam('request_id');
    const state = getSearchParam('state');
    const error = getSearchParam('error');

    if (!state) return '';
    if (!request_id && !error) return '';

    const storedState = localStorage.getItem('state');

    if (state !== storedState) {
        console.error('Authentication failed: Query parameter state did not match stored parameter.');
        alert('Vahva tunnistautuminen epäonnistui.');
        return '';
    }

    const stateObject: AuthCallbackState = decodeObject(state);

    const campaignService = ServicesJSON.find(
        campaignService => campaignService.id === stateObject.campaignUuid
    );

    if (!campaignService) {
        console.error('Incorrect campaignUuid in state, which does not match any know campaign');
        return '';
    }

    const language = stateObject.language || 'finnish';

    let languagePath = '';

    if      (language === 'english') languagePath = '/en';
    else if (language === 'swedish') languagePath = '/sv';

    const campaignPath: string|undefined = campaignService.path[language];

    if (!campaignPath) {
        console.error('Could not find path from campaign, with given language.');
        return '';
    }

    if (error) return `${languagePath}/${campaignPath}?state=${state}&error=${error}`;

    return `${languagePath}/${campaignPath}?request_id=${request_id}&state=${state}`;
};